/** NestJS API base URL including `/api` prefix (set at build time for staging/prod). */
export const API_BASE_URL =
  import.meta.env.VITE_API_URL ?? 'http://localhost:3000/api'
